import { render, staticRenderFns } from "./industryMall.vue?vue&type=template&id=841251e6&scoped=true"
import script from "./industryMall.vue?vue&type=script&lang=ts"
export * from "./industryMall.vue?vue&type=script&lang=ts"
import style0 from "./industryMall.vue?vue&type=style&index=0&id=841251e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841251e6",
  null
  
)

export default component.exports